var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.field && _vm.field.dependsOn)?_c('schema-search-select-multiple',_vm._g(_vm._b({staticClass:"flex-grow-1",attrs:{"value":_vm.value,"label":_vm.field.title,"rules":_vm.rules,"entity-key":_vm.field.dependsOn.entityKey,"search-when-blank":""}},'schema-search-select-multiple',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }